export const cleanFormData = <T extends Record<string, unknown>>(
  values: T,
): T => {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => [
      key,
      typeof value === "string" ? value.trim() : value,
    ]),
  ) as T;
};
